import { FirestoreCollections } from '@griply/types';
import { doc, getDoc } from 'firebase/firestore';
import { ID } from 'shared/types/id';

import { lifeAreaConverter } from './converters/life-area';
import { getDatabase } from './helpers';

export const getLifeAreaById = async (id: ID) => {
  return doc(getDatabase(), FirestoreCollections.LifeAreas, id).withConverter(
    lifeAreaConverter,
  );
};

export const getLifeAreaDocById = async (id: ID) => {
  const query = await getLifeAreaById(id);
  const snapshot = await getDoc(query);
  return snapshot.data();
};
